module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_PDF-Download_red-41787f3766bad81b97ec597755bab391.svg";